import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import styled from 'styled-components';

import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';

import { updateUser } from '../../actions/userActions';

import {
  FormGroup,
} from '../Styles/index';

const Success= styled.div`
  background-color: rgba(76, 175, 80, .25);
  padding: 16px;
  color: #2E7D32;
  border-radius: 4px;
  margin-bottom: 24px
`
const Warning = styled.div`
  background-color: rgba(244, 67, 54,.25);
  padding: 16px;
  color: #C62828;
  border-radius: 4px;
  margin-bottom: 24px
`

class UserChangePassword extends Component {
  state = {
    password: '',
    confirmPassword: '',
    error: null,
    success: false
  }

  _handleChange = event => {
    this.setState({
      [event.target.name]: event.target.value
    });
  }

  _handleSubmit = event => {
    event.preventDefault();
    if (this.state.password !== this.state.confirmPassword) {
      this.setState({
        error: "Password and Confirm Password are not the same!"
      })
      return;
    }
    this.setState({
      error: null
    })

    this.props.updateUser({
      userData: {
        password: this.state.password,
      },
      username: this.props.user.username
    }).then(_ => {
      if (this.props.userToUpdate.status === 'updated') {
        this.setState({
          success: true,
        })
        setTimeout(() => {
          this.props.closeDialog();
        }, 1000);
      }else{
        this.setState({
          error: "Password was not changed!"
        })
      }
    })
    console.log("ChangePasswordDialog submited");

  }

  render(){
    return(
      <form onSubmit={this._handleSubmit}>
        <FormGroup>
          Change password for <span style={{fontWeight: 700}}>{this.props.user.name}</span>'s account.
        </FormGroup>
        <FormGroup>
          <TextField
            fullWidth
            required
            type="password"
            id="password"
            name="password"
            floatingLabelText="Password"
            value={this.state.password}
            onChange={this._handleChange}
          />
        </FormGroup>
        <FormGroup>
          <TextField
            fullWidth
            required
            type="password"
            id="confirmPassword"
            name="confirmPassword"
            floatingLabelText="Confirm Password"
            value={this.state.confirmPassword}
            onChange={this._handleChange}
          />
        </FormGroup>
        <FormGroup>
          { this.state.success &&
            <Success>
              Password updated successfully!
            </Success>
          }
          { this.state.error &&
            <Warning>
              {this.state.error}
            </Warning>
          }
        </FormGroup>
        <FormGroup>
          <RaisedButton type='submit' label="Change Password" primary={true} />
          <FlatButton
            label="Cancel"
            primary={true}
            style={{marginLeft: '16px'}}
            onTouchTap={this.props.closeDialog}
          />
        </FormGroup>
      </form>
    )
  }
}

const mapStateToProps = state => ({ userToUpdate: state.user.updated });
const mapDispatchToProps = { updateUser };
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(UserChangePassword));



// WEBPACK FOOTER //
// ./src/components/Users/UserChangePassword.js